import { Injectable } from '@angular/core';
import { BotActionDTO } from '../Model/botActionDTO';
import { MapHelperService } from 'src/services/map-helper.service';
import { GeoClustersFrecuencyPlacesService } from 'src/app/features/map-features/sections/locations-section/services/GeoClustersFrecuencyPlaces.service';
import { LocationsService } from 'src/app/features/map-features/sections/locations-section/services/Locations.service';
import { LocationsMapService } from 'src/app/features/map-features/sections/locations-section/services/LocationsMap.service';
import { environment } from "src/environments/environment";
import { EncriptionService } from 'src/app/features/shared/services/Encription.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';

@Injectable({
  providedIn: 'root'
})
export class AzureBotService {

  //variables de identificacion de proyecto y usuario
    public userReferer = 'Mapix';
    public username = null;
    public password = null;
    public token = null;
    public signalIdentifier = null;

  // private tokenSubject = new BehaviorSubject<string | null>(null);

  constructor(private geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    private mapHelperService: MapHelperService,
    private locationsMapService: LocationsMapService,
    private encriptionService: EncriptionService,
    private locationsService: LocationsService,
    private localStorageService: LocalStorageService) {
  }

  startAction(data: any) {
    var actionDTO: BotActionDTO = JSON.parse(data);
    if(!environment.production) console.log("accion de signal",actionDTO);
    
    switch (actionDTO.actionName) {
      case "OpenLocationDetails":
        this.OpenLocationDetails(actionDTO.actionData);
        break;
      case "LocationRecurrentPlaces":
        this.RecurrentPlacesStart(actionDTO.actionData);
        break;
    
      default:
        break;
    }
  }

  OpenLocationDetails(actionData: any) {
    this.locationsService.setLoading(true);
    const identifier = actionData.identifier.toUpperCase();
    this.locationsMapService.onFocusPin(identifier);
  }

  RecurrentPlacesStart(actionData: any) {
    // this.locationsService.setLoading(true);
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(false);
    this.geoClustersFrecuencyCatalogService.setRecurrentPlaces(true);
    if(this.geoClustersFrecuencyCatalogService.isRecurrentPlacesVisible){
      const identifier = actionData.identifier.toUpperCase();
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = identifier;
    }else{
      this.geoClustersFrecuencyCatalogService.identifierRecurrentPlaces = "";
    }
  }

  setChanelData() {
    this.username = this.localStorageService.getUser();
    this.token = this.localStorageService.getToken();
    this.password = this.encriptionService.DecryptData(this.localStorageService.getPassword());
  }
}
